const DEFAULT_TIMEZONE = 'Asia/Tokyo';

export const toEpochMs = (value: unknown): number | null => {
    if (value === null || value === undefined) {
        return null;
    }
    if (typeof value === 'number' && Number.isFinite(value)) {
        return value < 100000000000 ? value * 1000 : value;
    }
    if (typeof value === 'string') {
        const trimmed = value.trim();
        if (!trimmed) {
            return null;
        }
        if (/^\d+$/.test(trimmed)) {
            const numeric = Number(trimmed);
            if (!Number.isFinite(numeric)) {
                return null;
            }
            return numeric < 100000000000 ? numeric * 1000 : numeric;
        }
        const parsed = Date.parse(trimmed);
        return Number.isNaN(parsed) ? null : parsed;
    }
    return null;
};

export const formatDateYmd = (value: unknown, timeZone: string = DEFAULT_TIMEZONE): string | null => {
    const ms = toEpochMs(value);
    if (ms === null) {
        return null;
    }
    return new Intl.DateTimeFormat('en-CA', {
        timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).format(new Date(ms));
};

export const getYearMonth = (value: unknown, timeZone: string = DEFAULT_TIMEZONE): { year: string; month: string } | null => {
    const ms = toEpochMs(value);
    if (ms === null) {
        return null;
    }
    const parts = new Intl.DateTimeFormat('en-CA', {
        timeZone,
        year: 'numeric',
        month: '2-digit',
    }).formatToParts(new Date(ms));
    const year = parts.find(part => part.type === 'year')?.value;
    const month = parts.find(part => part.type === 'month')?.value;
    if (!year || !month) {
        const fallback = new Date(ms);
        return {
            year: fallback.getFullYear().toString(),
            month: String(fallback.getMonth() + 1).padStart(2, '0'),
        };
    }
    return { year, month };
};

export const formatDateTime = (
    value: unknown,
    timeZone: string = DEFAULT_TIMEZONE,
    locale: string = 'ja-JP'
): string => {
    const ms = toEpochMs(value);
    if (ms === null) {
        return '';
    }
    return new Intl.DateTimeFormat(locale, {
        timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    }).format(new Date(ms));
};
